// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"ScriptingOffers-module--contentWrapper--qsr2D","wrapper":"ScriptingOffers-module--wrapper--1wXyw"};